/* global debounce, attachEvent, windowWidth */

// *******************************************************************************
// 1.0 - Mobile menu toggle
// *******************************************************************************

attachEvent('.mobile-hamburger', 'click', (ev) => {
  ev.preventDefault();

  // Close search
  document.body.classList.remove('is-open-search');

  // Open menu
  document.body.classList.toggle('is-open-menu');
  const hamburger = ev.target.closest('.mobile-hamburger');

  if (hamburger.classList.contains('is-open')) {
    hamburger.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
  } else {
    hamburger.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
  }
});

// *******************************************************************************
// 2.0 - Add class to body after some scroll
// *******************************************************************************
function addScrollingClass() {
  const topOffert = document.documentElement.scrollTop || document.body.scrollTop;

  if (topOffert > 200) {
    document.body.classList.add('is-scrolled');
  } else {
    document.body.classList.remove('is-scrolled');
  }
}

// Debounce the function to prevent multiple executions on scroll event
const debounceScroll = debounce(() => {
  addScrollingClass();
}, 100);

window.addEventListener('scroll', debounceScroll);

// *******************************************************************************
// 3.0 - Open and close language dropdown
// *******************************************************************************

const languageDropdown = document.querySelector('.language-dropdown');
const languageDropdownLabel = document.querySelector('.language-dropdown__label');

if (languageDropdown) {
  languageDropdownLabel.addEventListener('click', () => {
    if (windowWidth() <= 1140) {
      languageDropdown.classList.toggle('is-active');
    }
  });
}
